import { render, staticRenderFns } from "./DataMapper.vue?vue&type=template&id=5052be50"
import script from "./DataMapper.vue?vue&type=script&lang=js"
export * from "./DataMapper.vue?vue&type=script&lang=js"
import style0 from "./DataMapper.vue?vue&type=style&index=0&id=5052be50&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports